import { ZH, EN } from '@yaotai/common-utils';

const PHONE_LOGIN_VERIFICATION_CODE_INPUT_LOCALE = {
    [ZH]: {
        verificationCodePlaceholder: '请输入短信验证码',
        getVerificationCode: '获取验证码',
    },
    [EN]: {
        verificationCodePlaceholder: 'Enter SMS verification code',
        getVerificationCode: 'Send',
    },
};

export { PHONE_LOGIN_VERIFICATION_CODE_INPUT_LOCALE };
